import React from "react";
import { ReferenceAutocompleteInput, useFieldLabel } from "ra-friendsofbabba";

const MunicipalityInput = (props) => {
  const fieldLabel = useFieldLabel({ ...props });
  return (
    <ReferenceAutocompleteInput
      {...props}
      reference="municipalities"
      sort={{ field: "name", direction: "asc" }}
      optionText="name"
      helperText={fieldLabel("municipality_id.help")}
    />
  );
};
export default MunicipalityInput;
